<template>
  <div>
    <ticket
      :id="payment.id"
      :key="payment.id"
      ref="ticket"
      ></ticket>

    <v-row
      align="center"
      class="body-2 text--primary"
      @click="$refs.ticket.dialog = true"
      >
      <v-col
        cols="1"
        class="d-flex flex-row"
        style="gap: 4px"
        >
        <v-icon
          color="primary"
          v-if="payment.parentId"
          >
          mdi-source-branch
        </v-icon>

        <div>
          <div
            class="d-flex flex-row align-center caption"
            style="gap: 4px"
            >
            <v-tooltip 
              color="primary"
              right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="payment.thirdPartyTransfer"
                  v-on="on"
                  v-bind="attrs"
                  color="primary lighten-1"
                  >
                  mdi-bank-transfer
                </v-icon>
              </template>
              <span>Transferencia directa al locador por parte del locatario.</span>
            </v-tooltip>

            <div>
              #{{ payment.id }}
            </div>
          </div>

          <div
            class="caption d-flex flex-row align-center"
            style="gap: 4px"
            >
            <div
              v-if="payment.paidAt"
              >
              {{ (new Date(payment.paidAt)).toLocaleDateString() }}
            </div>

            <div
              v-else
              >
              Pend.
            </div>
          </div>
        </div>
      </v-col>

      <v-col
        cols="2"
        >
        {{ payment.subAccount.account.name }}
      </v-col>

      <v-col
        cols="3"
        >
        {{ payment.subAccount.name }}
      </v-col>

      <v-col
        cols="3"
        class="capitalize-text"
        >
        {{ payment.name }}
      </v-col>

      <v-col
        cols="2"
        >
        <div
          class="font-weight-medium"
          >
          {{ payment.concept }} 

          <v-tooltip 
            v-if="payment.detail"
            bottom
            color="primary"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-icon 
                class="mt-n1" 
                size="20" 
                color="primary" 
                v-on="on"
                v-bind="attrs"
                >
                mdi-file-document-outline
              </v-icon>
            </template>
            <span>{{ payment.detail }}</span>
          </v-tooltip>
        </div>

        <div
          v-if="payment.contractTag"
          class="caption"
          style="
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          "
          >
          {{ payment.contractTag }}
        </div>
      </v-col>

      <v-col
        cols="1"
        class="text-right font-weight-medium pl-0"
        :class="(Math.abs(payment.total) > payment.total) ? 'red--text' : ''"
        >
        {{ price(payment) }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Ticket from '@/components/payments/Ticket'

export default {
  props: {
    payment: {
      type: Object,
      required: true
    }
  },

  methods: {
    price (payment) {
      const options = { style: 'currency', currency: payment.currency };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(payment.total))
    }
  },

  components: {
    Ticket
  }
}
</script>
